export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGIN_VERIFY = 'LOGIN_VERIFY';
export const LOGIN_VERIFY_SUCCESS = 'LOGIN_VERIFY_SUCCESS';
export const VERIFY_TOKEN_JWT = 'VERIFY_TOKEN_JWT';
export const VERIFY_TOKEN_JWT_SUCCESS = 'VERIFY_TOKEN_JWT_SUCCESS';
export const LOGIN_API_ERROR = 'LOGIN_API_ERROR';
